import React from 'react'
import Home from './Starting/Home'

const App = () => {
  return (
    <div>
      <Home/>
    </div>
  )
}

export default App